import { Currency } from "../utils/currencyToSymbolMapper"
import { AxiosService } from "./AxiosService"

export type PricingTableProduct = {
    name: string
    priceId: string
    description?: string
    amount: number
    currency: Currency
    creditsAmount: number
    bestChoice: boolean
    attributes: string[]
    testMode: boolean
}

export const TokenService = new (class {
    activateTokens(userToken: string, accountId: string, feedNetworkId: string, days: number): Promise<void> {
        return AxiosService.postAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/tokens`, userToken, {
            accountId,
            feedNetworkId,
            days,
        })
    }

    createTokenCheckoutSession(userToken: string): Promise<{ name: string, data: PricingTableProduct[] }[]> {
        return AxiosService.getAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/tokenProducts`, userToken)
    }

    addAdminTokens(userToken: string, userId: string, tokenAmount: number): Promise<void> {
        return AxiosService.putAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/admin/tokens`, userToken, {
            userId,
            tokenAmount,
        })
    }
})()
